export const NOTIFICATION_TYPES_MAPPING = {
  CONVERSATION_MENTION: ['i-lucide-at-sign', 'text-n-blue-text'],
  CONVERSATION_ASSIGNMENT: ['i-lucide-chevrons-right', 'text-n-blue-text'],
  CONVERSATION_CREATION: ['i-lucide-mail-plus', 'text-n-blue-text'],
  PARTICIPATING_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-text',
  ],
  ASSIGNED_CONVERSATION_NEW_MESSAGE: [
    'i-lucide-message-square-plus',
    'text-n-blue-text',
  ],
  SLA_MISSED_FIRST_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_NEXT_RESPONSE: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  SLA_MISSED_RESOLUTION: ['i-lucide-heart-crack', 'text-n-ruby-11'],
  VIGIA_FINDING: ['i-lucide-siren', 'text-n-amber-11'],
  TASK_MENTION: ['i-lucide-at-sign', 'text-n-blue-text'],
  TASK_MEMBER_ADDED: ['i-lucide-user-plus', 'text-n-blue-text'],
  TASK_COMMENT: ['i-lucide-message-square', 'text-n-blue-text'],
  TASK_DUE: ['i-lucide-calendar-clock', 'text-n-amber-11'],
};

// Aviso de card de Tarefas: o alvo é o card (primary_actor = Task), não uma conversa.
export const isTaskNotification = notification =>
  (notification.primaryActorType || notification.primary_actor_type) === 'Task';

// Navegação do Inbox (ativo, anterior/próximo) só considera avisos de conversa.
export const conversationNotifications = list =>
  (list || []).filter(item => !isTaskNotification(item));

export const taskNotificationRoute = (notification, accountId) => {
  const actor = notification.primaryActor || notification.primary_actor || {};
  return {
    name: 'tasks_board_view',
    params: { accountId, boardId: actor.taskBoardId ?? actor.task_board_id },
    query: { card: actor.id },
  };
};
